const Recording = () => import(/* wepackChunkName: "recording" */ '@/components/recording/recording');
const RegistrationRecording = () => import(/* webpackChunkName: "registration" */ '@/components/registration/registration-recording');
const RecordingViewer = () => import(/* wepackChunkName: "recording" */ '@/components/recording/recording-viewer');

export default {
  path: 'recording',
  component: Recording,
  children: [
    {
      // recording/:recordingKey
      path: ':recordingKey',
      redirect: {name: 'recording-registration'}
    },
    {
      // recording/:recordingKey/register
      path: ':recordingKey/register',
      name: 'recording-registration',
      component: RegistrationRecording,
      props: true
    },
    {
      // recording/:recordingKey/view/:registrantKey
      path: ':recordingKey/view/:registrantKey',
      name: 'recording-view',
      component: RecordingViewer,
      props: (route) => ({
        recordingKey: route.params.recordingKey,
        registrantKey: route.params.registrantKey,
        controls: true
      })
    }
  ]
};
